import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'dmmp-path-link-template',
  templateUrl: './path-link-template.component.html'
})
export class PathLinkTemplateComponent {

  @Input() columItem
  @Input() identifier
  @Input() defaultClass
  @Output() page = new EventEmitter()
  @Output() anchorCustom = new EventEmitter()
  @Output() removeActive = new EventEmitter()

}
